import React from 'react';
import './styles.scss';

const About = props => {
    return (
        <div className="container-about">
            <div className="headbg">
                <div className="head">
                    About Us
                </div>
            </div>
            <div className="body">
                <div className="txt">
                    <strong>SOLAR SCIENTIST COMPANY LIMITED</strong> is a renowned and active commercial company incorporated by corporate affairs commission (CAC) under the company and allied matters act. We engage in the business of importation, marketing distribution, installation and maintenance, of solar energy services and alternative power products with a solid capital base and in substantial turnover. The watchword has been commercialized efficient services and customer’s satisfactory maximization. Our very strong presence in the commercial nerve center of the country is an eloquent testimony of our elaborate and efficient machinery gearing towards the provisions of unparalleled services to our client even at short notice and we are forever expanding.
                </div>
            </div>

            <div className="headbg">
                <div className="head">
                    What we offer
                    </div>
            </div>

            <div className="body">
                <div className="txt-head">
                    We undertake the following services which are cardinal points of our operations and organizational setup.
            </div>

                <div className="txt">

                    <strong>Importation and distribution of solar power products:</strong> Solar Scientist Company Limited is a foremost company in the importation, marketing and distribution of solar products. We involved in the importation and distribution of wholesale and retail quality standard Solar power product from some of the leading manufacturers of Solar product and our copartners example USA, Germany, India China, UK etc. Solar Scientist Company Limited supplies it product to Blue cheap companies and other unit that are in the same line of business. This follows all legal principles and guidelines relating to the importation and supply of its product and making sure that products supply is efficiently process to meet and exceed customers demand and satisfaction, without deviating from the legal regulatory policy guiding transaction between the two companies.
</div>
                <div className="txt">
                    <strong>Marketing of Solar inverter and other power products to individual and corporate bodies</strong> Solar Scientist Company Limited markets directly to individual and corporate bodies that are potentially ready to patronize it product and services, we offer after sales services by orientating our customers in order to efficiently use their solar product for longer duration. We also grant years of guarantee on all product depending on its manufacturer warranty and other factors according to the company’s marketing policy.
</div>
                <div className="txt">
                    <strong>Solar Power and Solar Product Information Resources:</strong> Through this means, Solar Scientist Company Limited is a one-stop shop window for all kind of information as they relate to Solar power generator and information about solar components. It hopes to create a large resort of information concerning solar power, solar inverter, solar panel and all alternative solar power products are on demand by our customers. It is a resource where ambiguities and uncertainties about a particular solar product as different individual and corporate bodies are laid to rest as the people will be treated to a compendium of answers as they are posed to the resources.
</div>
                <div className="txt">
                    <strong>Partnership with other solar power companies:</strong> Solar Scientist Company Limited is in progressive and result-oriented partnership with a lot of Solar power generator in Nigeria and in some countries across the global world. This is done with a view to spreading our reach to other parts of the country which our scope of operation will cover and will afford us the opportunity of extension and marketing of qualitative solar power products to far-reaching places so that our impact could be felt in such areas where our services are most needed.
</div>
                <div className="txt">
                    <strong>Supply and logistics for solar products distribution:</strong> The logistics for Solar power products distribution are taken into consideration in the discharge of our responsibilities and in meeting with acceptable standards and practices, the supply of our Solar power products is well managed and driven by the passion to excel and forge for greater heights. The company leaves no stone unturned in efficiently managing the logistics of Solar power products distribution across the continent at an agreed satisfactory rate to our potential business partners.

               </div>
            </div>

            <div className="headbg">
                <div className="head">
                    Our Achievements
                </div>

                <div className="column12">
                <div className="each-column">
                    <div className="txt-head2">
                        Our Achievement if far from comparison with any Solar company in Nigeria, we have executed top project in and outside the country, Example are as follows
                </div>
                    <div className="list">
                        <div className="for-each-list-item">
                            ~An execution of community street light pole in Katsina State.
                </div>
                        <div className="for-each-list-item">
                            ~500,000KVA Solar inverter installation to an estate in Bring-Ahafo one of Accra big cities in Ghana
                </div>
                        <div className="for-each-list-item">
                            ~1.5 MW Community light project by the state government in Nasarawa State
                </div>
                        <div className="for-each-list-item">
                            ~Our individual and corporate Services in the installation of street light and renewable power supply energy had exceeded 1500 project.
                </div>
                        <div className="for-each-list-item">
                            ~Construction of solar energy for federal medical Centre Lagos
                </div>
                    </div>

                    </div>
                    <div className="each-column">

                    <div className="txt-head2">
                        The operations and scope of Solar Scientist Company Limited is tailored on the following agenda:
                </div>
                    <div className="list">
                        <div className="for-each-list-item">
                            ~Importation of Solar panels, inverter and all renewable energy products.
                </div>
                        <div className="for-each-list-item">
                            ~Installation and Marketing of solar product, inverter and all renewable energy products.
                </div>
                        <div className="for-each-list-item">
                            ~Quality management in the distribution of Solar inverter and products to reach its end users
                </div>
                        <div className="for-each-list-item">
                            ~Creating Maximum Satisfaction for all potential customers patronizing our company through well trained solar expert with wide range of practical experience.
                </div>
                        <div className="for-each-list-item">
                            ~Sensitizing and orientating customers on the usage of different renewable solar generator purchased.
                </div>
                <div className="for-each-list-item">
                            ~Solar Inverter and all modern renewable energy information resource.
                </div>
                    </div>
                </div>
                </div>

                <div className="column4">

        <div className="head-wth">
          <span>
          Our Vision
          </span>
          </div>
          <div className="txt">
          <span>
          To be a front-runner in the importation, supply, distribution of solar, inverter, alternative power  and all renewable energy product at affordable rates and to make it accessible to the end users both in rural and urban centre.. 
To pioneer new inventions, innovations, ideas, and concepts of solar powered and all renewable energy products so as to improve the standard of living of the people and reduce risk attributed to the use of generator and negative effect of flames that comes from it.
To create new opportunities for the expansion of alternative power supply through improved efficient and management system empowered by current and latest information technology

          </span>
        </div>

        <div className="head-wth">
          <span>
          Our Mission
          </span>
          </div>
          <div className="txt">
          <span>
          To ensure sustainable power supply and improved quality of life by being a front-runner in the supply of Solar powered energy, alternative power products supply, training and recruitment of professional renewable energy expert driven by modern technological innovations
          </span>
        </div>

      </div>
            </div>
        </div>
    );
};

export default About;